import { RouteConfig } from 'vue-router';

export const coursesChildren: Array<RouteConfig> = [
  {
    path: 'overview',
    name: 'courses-overview',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "main" */ '../views/courses/Courses.vue')
  },
  {
    path: ':courseId',
    name: 'single-course',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "main" */ '../components/courses/single-course/SingleCourse.vue')
  },
  {
    path: '',
    redirect: {
      name: 'courses-overview'
    }
  }
];
